import UserImage from "components/commons/UserImage"
import { useTranslation } from "react-i18next"

export const HealthEventCard = ({
    onClick = () => { },
    event,
    showUser = true,
    template = "FULL" // FULL | COMPACT

}) => {

    const [t] = useTranslation(["health"])


    function getIcon() {
        switch (event.type) {
            case "FALL_DETECT": return <i className="fa-solid fa-person-falling "></i>
            case "NO_ACTIVITY": return <i className="fa-solid fa-ban "></i>
            case "HIGH_HR":
            case "LOW_HR": return <i className="fa-solid fa-heart-circle-exclamation"></i>
            case "BIA": return <i className="fa-solid fa-chart-pie"></i>
            case "ECG": return <i className="fa-solid fa-heart-pulse "></i>
            case "SPO2": return <i className="fa-solid fa-droplet "></i>
            default: return <i className="fa-solid fa-question "></i>
        }
    }

    function getColor() {
        switch (event.type) {
            case "FALL_DETECT":
            case "NO_ACTIVITY": return "darkred"
            case "HIGH_HR":
            case "LOW_HR": return "#4d0802"
            case "SPO2": return "#2962d2ff"
            case "BIA": return "#72982cff"
            case "ECG": return "#1a803bff"
            default: return "#2c363c"
        }
    }

    function getUnit() {
        switch (event.type) {
            case "FALL_DETECT": return "m/s^2"
            case "HIGH_HR":
            case "LOW_HR": return "bpm"
            case "BIA": return "%"
            case "SPO2": return "%"
            default: return null
        }
    }

    const formatTimestamp = (seconds) => {
        if (!seconds) return "";
        const date = new Date(seconds * 1000);
        const hours = date.getHours().toString().padStart(2, "0");
        const minutes = date.getMinutes().toString().padStart(2, "0");
        return `${hours}:${minutes}`;
    };

    const userDisplayName = () => {
        return event.user.displayName.split(" ")[0][0] + ". " + event.user.displayName.split(" ")[1]
    }

    const compactTemplate = () => {
        return <div key={event.timestamp} className="" style={{ backgroundColor: getColor() }}>

            <div className="d-flex align-items-center p-1">
                {
                    showUser &&
                    <div className="d-flex align-items-center gap-1  bg-opacity-50 bg-black bg-opacity-25 rounded-pill px-2">
                        <UserImage guid={event.user.guid} size={32} border={true} />
                        {userDisplayName()}
                    </div>
                }


                <div className="col text-end">
                    <small> {formatTimestamp(event.timestamp)}</small>
                </div>
            </div>

            <div className="d-flex align-items-center justify-content-between p-1">
                <b>  {getIcon()} {t(`health:entity.events.${event.type}`)}</b>
                <small className="opacity-75">{event.value} <small className="opacity-50">{getUnit()}</small></small>
            </div>


        </div>
    }

    const compactV2Template = () => {
        return <div key={event.timestamp} className="card mb-1" style={{ backgroundColor: getColor() }} onClick={onClick}>


            <div className="card-header">
                <div className="d-flex align-items-center justify-content-between">
                    <small> {formatTimestamp(event.timestamp)}</small>
                    <div className="d-flex align-items-center gap-1  bg-opacity-50 bg-black bg-opacity-25 rounded-pill px-2 py-1">
                        {showUser && <UserImage guid={event.user.guid} size={32} border={true} />}
                        {showUser && userDisplayName()}
                    </div>


                </div>
            </div>
            <div className="card-body">
                <div className="d-flex align-items-center justify-content-between">

                    <span><i className="opacity-50">{getIcon()} </i>{t(`health:entity.events.${event.type}`)}</span >
                    <small className="opacity-75">{event.value} <small className="opacity-50">{getUnit()}</small></small>
                </div>

            </div>

        </div>
    }

    const fullTemplate = () => {
        return <div key={event.timestamp} className="card" style={{ backgroundColor: getColor() }}>
            <div className="card-body">
                <div className="d-flex align-items-center justify-content-between">
                    <div className="col text-start">
                        {getIcon()}
                    </div>
                    <div className="col text-end">
                        <small> {formatTimestamp(event.timestamp)}</small>
                    </div>
                </div>
                <div className="d-flex align-items-center justify-content-between mt-2">

                    <b>{t(`health:entity.events.${event.type}`)}</b>
                    <small className="opacity-75">{event.value} <small className="opacity-50">{getUnit()}</small></small>
                </div>
                <div className="d-flex align-items-center gap-1 mt-3 bg-opacity-50 bg-black bg-opacity-25 rounded-pill ">

                    {showUser && <UserImage guid={event.user.guid} size={32} border={true} />}

                    {
                        showUser &&
                        userDisplayName()
                    }
                </div>
            </div>

        </div>
    }


    return (
        template == "FULL" ?
            compactV2Template()
            : compactTemplate()

    )




}